import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const checkSuiteName = async ({ testSuite, prodId }) => {
  const user = getUserDetails();
  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}`, {
    params: {
      action: "checkForTestSuiteInProduct",
      companyid: user.companyid,
      testSuite,
      prodId,
    },
  });
  return response.data;
};

const useCheckSuiteNameQuery = ({ testSuite, prodId }, options = {}) => {
  return useQuery({
    queryKey: ["checkSuiteName", testSuite, prodId],
    queryFn: () => checkSuiteName({ testSuite, prodId }),
    enabled: !!testSuite && !!prodId,
    ...options,
  });
};

export default useCheckSuiteNameQuery;
